import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Integrations from "../../../integration/Integrations.jsx";

class ZendeskSellOrderFromQuoteCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
            quote: nextProps.quote || null,
        })
    }

    render() {
        let url = Integrations.getExternalOrderUrl(this.state.object)
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    <FormattedMessage
                        id="quote.analytics.events.zendesk_sell.order_created_from.text"
                        defaultMessage="The quote {quote} has been created from the deal {order}"
                        values={{
                            order: <strong>
                                <a href={Integrations.getExternalOrderUrl(this.state.object)} target={'_blank'}>
                                    #{this.state.object.attributes.externalId}
                                </a>
                            </strong>,
                            quote: <strong>{this.state.quote.attributes.identifier}</strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={url} target={'_blank'}>
                        <img src="/images/zendesk_sell_logo.png" width="150px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={url} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="invoice.analytics.events.order.zendesk_sell.open"
                                defaultMessage="Open deal in Zendesk Sell"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default ZendeskSellOrderFromQuoteCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-from-quote-created-zendesk-sell.component.jsx